// XXX: We are required to include this file by law.
/*

 MyFonts Webfont Build ID 2816178, 2014-05-21T16:46:21-0400

 The fonts listed in this notice are subject to the End User License
 Agreement(s) entered into by the website owner. All other parties are␣
 explicitly restricted from using the Licensed Webfonts(s).

 You may obtain a valid license at the URLs below.

 Webfont: Brandon Text Regular by HVD Fonts
 URL: http://www.myfonts.com/fonts/hvdfonts/brandon-text/regular/
 Copyright: Copyright (c) 2012 by Hannes von Doehren. All rights reserved.
 Licensed pageviews: 250,000


 License: http://www.myfonts.com/viewlicense?type=web&buildid=2816178

 ? 2014 MyFonts Inc
*/
var count = window.document.createElement('link');
count.rel = "stylesheet";
count.href = "https://hello.myfonts.net/count/2af8b2";
var s = document.getElementsByTagName("script")[0];
s.parentNode.insertBefore(count, s);
